var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.adFailed)?_c(_setup.GridRowLabel,{staticClass:"dark",attrs:{"label":_vm.$tc('WEBAPP_PROMOTED')}},[_c(_setup.PreRollVideoAd,{staticClass:"grid-preroll",attrs:{"adUnit":"exp_underperforming_urls_5_V1"},on:{"adFailed":function($event){_setup.adFailed = true}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }